import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export default function BackButton({ to, label, className }) {
  return (
    <Button asChild variant="ghost" size="sm" className={cn("-ml-2 mb-3", className)}>
      <Link to={to}>
        <ChevronLeft className="h-4 w-4 mr-1" aria-hidden="true" />
        {label}
      </Link>
    </Button>
  );
}
